import { useEffect } from "react";
import Header from "./Header";

interface PageLayoutProps {
  notice?: React.ReactNode;
  children: React.ReactNode;
}

export default function PageLayout({ notice, children }: PageLayoutProps) {
  // TRIPPANG 로고바 하단 위치를 CSS 변수로 전달 (팝업 위치용)
  useEffect(() => {
    const update = () => {
      const titleBar = document.getElementById("title-bar");
      if (titleBar) {
        const h = titleBar.offsetTop + titleBar.offsetHeight;
        document.documentElement.style.setProperty("--title-h", `${h}px`);
      }
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);
  return (
    <div className="flex flex-col bg-slate-950 text-slate-900 overflow-x-hidden" style={{ height: "100dvh" }}>
      {notice}
      <Header />
      <main className="flex flex-1 min-h-0 flex-col overflow-hidden">{children}</main>
    </div>
  );
}
